module.exports = __webpack_public_path__ + "static/media/Flaticon.9106517e.woff";